import Calculator from "../components/Calculator";

const Main = () => {
  return (
      <div className="main">
        <Calculator/>
        <div className="shape-left"></div>
        <div className="shape-right"></div>
      </div>
  );
};

export default Main;
